(function () {

  function showMsg(wrapper, text, isError) {
    const el = wrapper.querySelector("[data-bulk-msg]");
    if (!el) return;
    el.textContent = text;
    el.style.display = "block";
    el.style.color = isError ? "red" : "";
  }

  async function bulkAdd(wrapper) {
    const inputs = wrapper.querySelectorAll("input[data-variant-id]");
    const items = [];
    const errors = [];

    inputs.forEach((input) => {
      const qty = parseInt(input.value, 10);
      const id = input.getAttribute("data-variant-id");
       const title = input.dataset.variantTitle || "This variant";
      const max = parseInt(input.dataset.max, 10);

      if (!id || isNaN(qty) || qty <= 0) return;

      // If max is a real number, enforce it
      if (!isNaN(max) && qty > max) {
        //errors.push(`Variant ${id}: requested ${qty}, available ${max}`);
        errors.push(`${title}: requested ${qty}, available in stock ${max}`);

        return;
      }

      items.push({ id: Number(id), quantity: qty });
    });

    if (errors.length) {
      showMsg(
        wrapper,
        "Not added. Some quantities exceed inventory:\n" + errors.join("\n"),
        true,
      );
      return;
    }

    if (!items.length) {
      showMsg(wrapper, "Enter at least one quantity.", true);
      return;
    }

    const btn = wrapper.querySelector("[data-bulk-add]");
    if (btn) btn.disabled = true;

    try {
      const res = await fetch("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ items }),
      });

      if (!res.ok) throw new Error(await res.text());

      showMsg(wrapper, "Added to cart!", false);
      window.location.href = "/cart";
    } catch (e) {
      showMsg(wrapper, "Error adding to cart. " + (e.message || ""), true);
      if (btn) btn.disabled = false;
    }
  }

  function init() {
    document.querySelectorAll(".variant-qty-grid").forEach((wrapper) => {
      const btn = wrapper.querySelector("[data-bulk-add]");
      if (!btn) return;

      btn.addEventListener("click", function () {
        bulkAdd(wrapper);
      });
    });
  }

  // Run on initial load
  document.addEventListener("DOMContentLoaded", init);

  // Run on Shopify section reloads (theme editor / dynamic sections)
  document.addEventListener("shopify:section:load", init);
})();
